import '@/assets/styles/app.scss';

import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/index';
import { CreateElement } from 'vue/types/umd';
import { i18n } from '@/localization';
import '@/registerServiceWorker';
import '@/layouts/index';
import '@/assets/svg/_index';

// @ts-ignore
import LoadScript from 'vue-plugin-load-script';
// @ts-ignore
Vue.use(LoadScript);

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

// @ts-ignore
import 'lazysizes';
// @ts-ignore
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// @ts-ignore
import TextareaAutosize from 'vue-textarea-autosize';
Vue.use(TextareaAutosize);

// @ts-ignore
import vueMoment from 'vue-moment';
import moment from 'moment';
require('moment/locale/nl');
Vue.use(vueMoment, { moment });

// @ts-ignore
import vuescroll from 'vue-scroll';
Vue.use(vuescroll);

// @ts-ignore
import VueConfetti from 'vue-confetti';
Vue.use(VueConfetti);

// @ts-ignore
import EasyRefresh from 'vue-easyrefresh';
Vue.use(EasyRefresh);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: (h: CreateElement) => h(App),
    data: () => ({
        breakpoints: ['xs'],
        isMobile: true,
        isTablet: false,
        isDesktop: false,
    }),
    mounted() {
        // @ts-ignore
        this.init();
        const self = this;
        // @ts-ignore
        window.addEventListener('resize', () => self.init());
        // @ts-ignore
        window.addEventListener('orientationchange', () => self.init());
    },

    methods: {
        init() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            this.breakpoints = ['xs'];
            this.isMobile = true;
            this.isTablet = false;

            if (window.innerWidth >= 576) {
                this.breakpoints = ['xs', 'sm'];
            }
            if (window.innerWidth >= 768) {
                this.breakpoints = ['xs', 'sm', 'md'];
            }
            if (window.innerWidth >= 1024) {
                this.breakpoints = ['xs', 'sm', 'md', 'lg'];
                this.isMobile = false;
                this.isTablet = true;
            }
            if (window.innerWidth >= 1200) {
                this.breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
            }
        },
        getHumanizedTestScore(score: number, slug: string) {
            switch (slug) {
                case 'uw-motivatieprofiel':
                    if (score <= 8) {
                        return this.$t(`components.tests.${slug}.scores.high_motivation`);
                    }

                    if (score <= 16) {
                        return this.$t(`components.tests.${slug}.scores.mild_motivation`);
                    }

                    if (score <= 24) {
                        return this.$t(`components.tests.${slug}.scores.low_motivation`);
                    }

                    break;
                case 'rokersprofiel':
                    if (score === 0) {
                        return this.$t(`components.tests.${slug}.scores.ultra_light`);
                    }

                    if (score === 3) {
                        return this.$t(`components.tests.${slug}.scores.light`);
                    }

                    if (score === 6) {
                        return this.$t(`components.tests.${slug}.scores.medium`);
                    }

                    if (score === 9) {
                        return this.$t(`components.tests.${slug}.scores.heavy`);
                    }

                    break;
                case 'toesteladvies':
                    if (score <= 0) {
                        return this.$t(`components.tests.${slug}.scores.open_system`);
                    }
                    if (score > 0) {
                        return this.$t(`components.tests.${slug}.scores.closed_system`);
                    }

                    break;
                case 'jouw-toestel':
                    if (score === 0) {
                        return this.$t(`components.tests.${slug}.scores.open_system`);
                    }
                    if (score === 1) {
                        return this.$t(`components.tests.${slug}.scores.closed_system`);
                    }

                    break;
                case 'liquids-per-week':
                    break;
                case 'de-fagerstrom-test':
                    if (score <= 4.8) {
                        return this.$t(`components.tests.${slug}.scores.very_low`);
                    }

                    if (score <= 9.6) {
                        return this.$t(`components.tests.${slug}.scores.low`);
                    }

                    if (score <= 12) {
                        return this.$t(`components.tests.${slug}.scores.average`);
                    }

                    if (score <= 16.8) {
                        return this.$t(`components.tests.${slug}.scores.high`);
                    }

                    if (score <= 24) {
                        return this.$t(`components.tests.${slug}.scores.very_high`);
                    }

                    break;
            }

            return this.$t(`components.tests.unkown_score`);
        },
    },
}).$mount('#app');
